import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { FilterData } from '../../filter';
import { formatDate as angularFormatDate } from '@angular/common';

@Component({
  selector: 'atm-filter-editor-input',
  templateUrl: './filter-editor-input.component.html',
  styleUrls: ['./filter-editor-input.component.scss'],
})
export class FilterEditorInputComponent implements OnChanges {
  @Input() data: FilterData | null = null;
  @Input() quickSearch: boolean = false;
  @Input() disabled: boolean = true;
  @Output() setFilter = new EventEmitter<FilterData>();
  @Output() filtering = new EventEmitter<boolean>();
  private readonly destroyed = new Subject<void>();

  form: FormGroup;
  currentOperation: string = '';
  currentValue: string = '';

  get filterControl(): FormControl {
    return this.form.get('filter') as FormControl;
  }
  get operationControl(): FormControl {
    return this.form.get('operation') as FormControl;
  }
  get valueControl(): FormControl {
    return this.form.get('value') as FormControl;
  }

  formatDate(date: Date | string | null): string {
    if (!date) return '';
    return angularFormatDate(date, 'yyyy-MM-dd', 'en-US');
  }

  constructor(fb: FormBuilder) {
    this.form = fb.group({
      filter: [this.data?.filter, Validators.required],
      operation: [this.data?.operation, Validators.required],
      value: [this.data?.value, Validators.required],
    });
    this.operationControl.valueChanges
      .pipe(debounceTime(128), distinctUntilChanged())
      .subscribe((value) => {
        if (this.currentOperation === 'isset') {
          this.form.get('value')?.patchValue(this.currentValue);
        }
        this.currentOperation = value;
        if (this.valueControl.value && this.valueControl.value !== '') {
          this.setFilter.next(this.form.value);
        }
      });
    this.valueControl.valueChanges
      .pipe(debounceTime(128), distinctUntilChanged())
      .subscribe((value) => {
        if(value && this.data?.filter?.type === 'date'){
          this.form.get('value')?.patchValue(this.formatDate(value));
        } else if (this.currentOperation !== 'isset') {
          this.currentValue = value;
        }

        if (value && value !== '') {
          this.setFilter.next(this.form.value);
        }
      });
  }

  ngOnChanges(): void {
    this.filterControl.patchValue(this.data?.filter);
    this.operationControl.patchValue(this.data?.operation);
    this.valueControl.patchValue(this.data?.value);
    if (!this.quickSearch) {
      if (this.disabled) {
        this.operationControl.disable();
        this.valueControl.disable();
      } else {
        this.operationControl.enable();
        this.valueControl.enable();
      }
    }
  }

  propagateChange() {
    this.filtering.next(this.valueControl.value);
  }
}
